(() => {
    if (window.SperkyProductPageLimitGuard) return;
    window.SperkyProductPageLimitGuard = true;

    let popupTimer;

    function showMaximumQuantityPopup() {
      let popup = document.querySelector(
        '[data-sperky-max-quantity-popup]'
      );

      if (!popup) {
        popup = document.createElement('div');
        popup.setAttribute(
          'data-sperky-max-quantity-popup',
          ''
        );
        popup.setAttribute('role', 'alert');
        popup.setAttribute('aria-live', 'assertive');

        Object.assign(popup.style, {
          position: 'fixed',
          left: '50%',
          bottom: 'calc(env(safe-area-inset-bottom) + 85px)',
          transform: 'translate(-50%, 15px)',
          width: 'calc(100% - 32px)',
          maxWidth: '420px',
          zIndex: '999999',
          padding: '14px 18px',
          background: '#ffffff',
          color: '#111111',
          border: '1.5px solid #ec2f8a',
          borderRadius: '14px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
          fontSize: '14px',
          fontWeight: '600',
          lineHeight: '1.4',
          textAlign: 'center',
          opacity: '0',
          visibility: 'hidden',
          transition:
            'opacity .2s ease, transform .2s ease, visibility .2s ease'
        });

        document.body.appendChild(popup);
      }

      popup.textContent =
        'Maximum available quantity of this item is already in your cart.';

      popup.style.visibility = 'visible';
      popup.style.opacity = '1';
      popup.style.transform = 'translate(-50%, 0)';

      clearTimeout(popupTimer);

      popupTimer = setTimeout(() => {
        popup.style.opacity = '0';
        popup.style.transform = 'translate(-50%, 15px)';

        setTimeout(() => {
          popup.style.visibility = 'hidden';
        }, 200);
      }, 3000);
    }

    document.addEventListener(
      'click',
      async (event) => {
        const button = event.target.closest(
          'main button[data-testid="standalone-add-to-cart"][name="add"]'
        );

        if (!button) return;

        if (
          button.dataset.sperkyProductLimitPassed === 'true'
        ) {
          delete button.dataset.sperkyProductLimitPassed;
          return;
        }

        const component = button.closest(
          'add-to-cart-component'
        );

        const form = button.closest('form');

        const variantInput = form?.querySelector(
          'input[name="id"]'
        );

        const quantityInput = form?.querySelector(
          'input[name="quantity"]'
        );

        const limitsElement = component?.querySelector(
          '[data-sperky-product-variant-limits]'
        );

        if (!form || !variantInput || !limitsElement) {
          return;
        }

        let limits;

        try {
          limits = JSON.parse(
            limitsElement.textContent || '{}'
          );
        } catch (error) {
          return;
        }

        const variantId = Number(variantInput.value);

        const requestedQuantity = Math.max(
          1,
          Number(quantityInput?.value || 1)
        );

        const rawMaximum = limits[String(variantId)];

        if (
          rawMaximum === null ||
          rawMaximum === undefined
        ) {
          return;
        }

        const maximumQuantity = Number(rawMaximum);

        if (!Number.isFinite(maximumQuantity)) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (
          button.dataset.sperkyProductLimitPending === 'true'
        ) {
          return;
        }

        button.dataset.sperkyProductLimitPending = 'true';

        try {
          const root =
            window.Shopify?.routes?.root || '/';

          const response = await fetch(
            `${root}cart.js`,
            {
              credentials: 'same-origin',
              cache: 'no-store',
              headers: {
                Accept: 'application/json'
              }
            }
          );

          if (!response.ok) {
            throw new Error('Unable to check cart');
          }

          const cart = await response.json();

          const quantityAlreadyInCart = (
            cart.items || []
          ).reduce((total, item) => {
            if (
              Number(item.variant_id) === variantId
            ) {
              return (
                total + Number(item.quantity || 0)
              );
            }

            return total;
          }, 0);

          if (
            quantityAlreadyInCart +
              requestedQuantity >
            maximumQuantity
          ) {
            button.removeAttribute('data-added');
            showMaximumQuantityPopup();
            return;
          }

          button.dataset.sperkyProductLimitPassed =
            'true';

          button.click();
        } catch (error) {
          button.dataset.sperkyProductLimitPassed =
            'true';

          button.click();
        } finally {
          delete button.dataset
            .sperkyProductLimitPending;
        }
      },
      true
    );
  })();

  (() => {
    if (window.SperkyQuickAddLimitGuard) return;
    window.SperkyQuickAddLimitGuard = true;

    let popupTimer;

    function showMaximumQuantityPopup() {
      let popup = document.querySelector(
        '[data-sperky-max-quantity-popup]'
      );

      if (!popup) {
        popup = document.createElement('div');
        popup.setAttribute('data-sperky-max-quantity-popup', '');
        popup.setAttribute('role', 'alert');
        popup.setAttribute('aria-live', 'assertive');

        popup.textContent =
          'Maximum available quantity is already in your cart.';

        Object.assign(popup.style, {
          position: 'fixed',
          left: '50%',
          bottom: 'calc(env(safe-area-inset-bottom) + 90px)',
          transform: 'translate(-50%, 15px)',
          width: 'calc(100% - 32px)',
          maxWidth: '420px',
          zIndex: '999999',
          padding: '14px 18px',
          background: '#ffffff',
          color: '#111111',
          border: '1.5px solid #ec2f8a',
          borderRadius: '14px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
          fontSize: '14px',
          fontWeight: '600',
          lineHeight: '1.4',
          textAlign: 'center',
          opacity: '0',
          visibility: 'hidden',
          transition:
            'opacity .2s ease, transform .2s ease, visibility .2s ease'
        });

        document.body.appendChild(popup);
      }

      popup.style.visibility = 'visible';
      popup.style.opacity = '1';
      popup.style.transform = 'translate(-50%, 0)';

      clearTimeout(popupTimer);

      popupTimer = setTimeout(() => {
        popup.style.opacity = '0';
        popup.style.transform = 'translate(-50%, 15px)';

        setTimeout(() => {
          popup.style.visibility = 'hidden';
        }, 200);
      }, 3000);
    }

    document.addEventListener(
      'click',
      async (event) => {
        const button = event.target.closest(
          'quick-add-component .quick-add__button--add'
        );

        if (!button) return;

        if (button.dataset.sperkyLimitCheckPassed === 'true') {
          delete button.dataset.sperkyLimitCheckPassed;
          return;
        }

        const form = button.closest('form');
        const variantInput =
          form?.querySelector('input[name="id"]');
        const quantityInput =
          form?.querySelector('input[name="quantity"]');
        const limitsElement =
          form?.querySelector('[data-sperky-variant-limits]');

        if (!form || !variantInput || !limitsElement) return;

        let limits;

        try {
          limits = JSON.parse(limitsElement.textContent || '{}');
        } catch (error) {
          return;
        }

        const variantId = Number(variantInput.value);
        const requestedQuantity = Math.max(
          1,
          Number(quantityInput?.value || 1)
        );

        const rawMaximum = limits[String(variantId)];

        if (rawMaximum === null || rawMaximum === undefined) {
          return;
        }

        const maximumQuantity = Number(rawMaximum);

        if (!Number.isFinite(maximumQuantity)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (button.dataset.sperkyLimitCheckPending === 'true') {
          return;
        }

        button.dataset.sperkyLimitCheckPending = 'true';

        try {
          const root = window.Shopify?.routes?.root || '/';

          const response = await fetch(`${root}cart.js`, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              Accept: 'application/json'
            }
          });

          if (!response.ok) {
            throw new Error('Unable to check cart');
          }

          const cart = await response.json();

          const quantityAlreadyInCart = (cart.items || []).reduce(
            (total, item) => {
              if (Number(item.variant_id) === variantId) {
                return total + Number(item.quantity || 0);
              }

              return total;
            },
            0
          );

          if (
            quantityAlreadyInCart + requestedQuantity >
            maximumQuantity
          ) {
            showMaximumQuantityPopup();
            return;
          }

          button.dataset.sperkyLimitCheckPassed = 'true';
          button.click();
        } catch (error) {
          button.dataset.sperkyLimitCheckPassed = 'true';
          button.click();
        } finally {
          delete button.dataset.sperkyLimitCheckPending;
        }
      },
      true
    );
  })();